import {Dictionary} from "../types/rendering";

export type NavigationTypes = "MainPage" | "Popup";

export interface NavigationInfo
{
    navigationType: NavigationTypes;
    href: string;
}

export interface LinkSpec
{
    tag?: "a" | "button";
    TargetType?: string;
    Metadata?: Dictionary;
    AppeventName?: string;
    PreAlme?: (e: unknown) => void;
    disabled?: boolean;
    DisplayText: string;
    parameters: Dictionary;
    id?: string;
    attributes?: {
        [key: string]: string;
    };
    className: string;
    navigationInfo?: NavigationInfo;
}

export interface ButtonCollectionSettings
{
    buttonCollection: {
        buttonConfigs: LinkSpec[];
    };
}

export default  {
    buttonCollection: {
        buttonConfigs: [] as LinkSpec[],
    },
} as ButtonCollectionSettings;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/button-collection.ts